<template>
  <AppSection id="scope-dashboard" :title="$getConst.pages.scopeSettingDashboard.scope_settings" type="section" :is-section-loading="is_loading">
    <b-row class="justify-content-center">
      <template v-for="option in options">
        <b-col
          xl="3" lg="4" md="4" sm="6"
          class="pb-4"
          v-if="!is_loading && cardIsAvailable(option)"
        >
          <AppPageOptionBox
            :icon="option.icon"
            :text="option.text"
            @onClick="goToRoute(option.routeName)"
          />
        </b-col>
      </template>
    </b-row>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import AppPageOptionBox from "../../../../components/common/utils/AppPageOptionBox";
  import scopeSettings from "../scopeSettings";
  import {getOneScope} from "../../../../api/scopes.api";
  export default {
    name: "index",
    components: {AppPageOptionBox, AppSpinner, AppSection},
    data() {
      return {
        options: scopeSettings,
        scope: null,
        is_loading: false
      }
    },
    props: {
      scope_id: null,
      scope_name: null,
    },
    methods: {
      goToRoute(routeName) {
        this.$router.push({name: routeName});
      },
      cardIsAvailable(option){
        return ((!option.roles && !option.permissions) ||
          (option.roles && option.roles.length && this.hasRole(option.roles)) ||
          (option.permissions && option.permissions.length && this.hasAnyOfPermissions(option.permissions))) &&
          (
            this.scope.is_timesheets_enabled && option.applicationOptions.includes('timesheets') ||
            this.scope.is_invoices_enabled && option.applicationOptions.includes('invoices')
          )
      },
      getScope() {
        this.is_loading = true;
        getOneScope(this.scope_id).then(
          response => {
            this.scope = response.data;
            this.is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.is_loading = false;
          }
        )
      }
    },
    created() {
      this.getScope();
    }
  }
</script>

<style scoped>

</style>
